<script setup lang="ts">
import { FdxButton } from '@foodics/ui-common';
import { useLocale } from '@/composables/locale';

const { t } = useLocale();

function reload() {
    window.location.reload();
}
</script>

<template>
    <Transition
        appear
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="opacity-0 translate-y-full"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 translate-y-full"
    >
        <div
            role="alert"
            class="fixed bottom-4 end-4 z-50 max-w-sm rounded-lg bg-white shadow-lg border border-gray-200 p-4 flex gap-x-3 items-start"
        >
            <div class="flex-1 min-w-0">
                <p class="font-semibold text-gray-900">
                    {{ t('generic.app_update.title') }}
                </p>
                <p class="text-sm text-gray-600 mt-1">
                    {{ t('generic.app_update.message') }}
                </p>
                <div class="mt-3 flex justify-end">
                    <FdxButton size="sm" @click="reload">
                        {{ t('generic.app_update.reload') }}
                    </FdxButton>
                </div>
            </div>
        </div>
    </Transition>
</template>
